import { Box } from '@mui/material'
import React from 'react'
import { keyTest } from '../../../../utility'

export function ItemCountColumn<T extends { id: number }>({
  item,
  columnData: { key },
}: {
  item: T
  columnData: { key: string }
}) {
  if (!keyTest(item, key)) return <Box />
  const itemList = item[key]
  if (!Array.isArray(itemList)) return <Box />
  return (
    <Box>
      {key}: {itemList.length}
    </Box>
  )
}
